import mixpanel from "mixpanel-browser";

import { s3MultipartUpload } from "./SignS3";
import { bytesToMB } from "./utils";

export async function uploadToCloud({
  blob,
  createNewNote,
  jobType,
  uploadStatus = {},
  setUploadStatus = () => {},
  syncedRecordingUUID = undefined,
  isNoteFromFileUpload = false,
  recordingAs = null,
  title = null,
  recordingRef = null,
  recordingConsentEventUuid = null,
}) {
  const fileSizeMB = bytesToMB(blob.size).toFixed(2);
  const uploadStartTime = Date.now();

  try {
    mixpanel.track("Upload Started", {
      fileSizeMB,
      syncedRecordingUUID,
      recordingRef,
    });
    var { storageObjectName, audioStorageLink } =
      await s3MultipartUpload(
        blob,
        uploadStatus,
        setUploadStatus,
        syncedRecordingUUID,
      );
  } catch (error) {
    mixpanel.track("S3 upload failed", {
      fileSizeMB,
      error: error.message || error,
      storageObjectName,
      audioStorageLink,
      syncedRecordingUUID,
      recordingRef,
    });
    throw error; // Re-throw for parent function to catch
  } finally {
    setTimeout(() => {
      setUploadStatus({
        numChunksTotal: 0,
        numChunksCompleted: 0,
      });
    }, 2000);
  }
  const elapsedTime = (Date.now() - uploadStartTime) / 1000;
  mixpanel.track("Upload Completed", {
    elapsedTime,
    syncedRecordingUUID,
    recordingRef,
  });
  try {
    const newNoteData = await createNewNote(
      audioStorageLink,
      storageObjectName,
      jobType,
      !!syncedRecordingUUID,
      isNoteFromFileUpload,
      recordingAs,
      title,
      recordingConsentEventUuid,
    );
    return { success: true, note: newNoteData };
  } catch (error) {
    mixpanel.track("Note Creation Failed", {
      fileSizeMB,
      error: error.message || error,
      storageObjectName,
      audioStorageLink,
      syncedRecordingUUID,
      recordingRef,
    });
    throw error; // Re-throw for parent function to catch
  }
}

export async function submitTestingSampleAudio({
  createNewNote,
  audioUrl,
}) {
  /**
   * Used for submitting testing audio files if the tester chooses to use pre-record
   *
   * Why are we doing this?
   * Cause the user needs a NEW note so that they can edit it and see it in their dashboard after the process.
   * However, we need to make that new note with an audio file. So saving the file in assets, then getting the
   *   blob, then uploading the file with the same function as regular recordings used seems to keep things clean
   * while allowing a new note to be created every time.
   *
   */

  const importedAudioUrl = audioUrl;

  fetch(importedAudioUrl)
    .then((response) => response.blob())
    .then((blob) => {
      uploadToCloud({ blob, createNewNote });
    })
    .catch(() => {
      alert(
        "error",
        "An error occurred. Please try again later or contact Scribenote Support.",
      );
    });
}
